import { States } from './holovideoobject';
export class HoloVideoFrontEnd {
    state;
    _onEndOfStream;
    _hvo;
    _fileInfo;
    _hvoOnEndOfStream(hvo) {
        if (this._onEndOfStream) {
            this._onEndOfStream(this);
        }
    }
    get onUpdateCurrentFrame() {
        return this.hvo.onUpdateCurrentFrame;
    }
    set onUpdateCurrentFrame(callback) {
        this.hvo.onUpdateCurrentFrame = callback;
    }
    get hvo() {
        return this._hvo;
    }
    constructor(context, callback, createOptions, updateCurrentFrameCallback, errorCallback) {
        const hvo = this._createHoloVideoObject(context, createOptions, updateCurrentFrameCallback, errorCallback);
        this._hvo = hvo;
        hvo.onEndOfStream = this._hvoOnEndOfStream.bind(this);
        hvo.onUpdateCurrentFrame = updateCurrentFrameCallback;
        hvo.onLoaded = (fileInfo) => {
            this._fileInfo = fileInfo;
            this.state = this._hvo.state;
            callback(fileInfo);
        };
    }
    open(url, options) {
        if (this.state > States.Empty) {
            this.close();
        }
        this._hvo.open(url, options);
        this.state = this._hvo.state;
    }
    update() {
        if (this._hvo) {
            this.state = this._hvo.state;
        }
        this._hvo.updateBuffers();
    }
    rewind() {
        this._hvo.rewind();
    }
    seekToTime(seekTime, displayImmediately) {
        this._hvo.seekToTime(seekTime, displayImmediately);
    }
    play() {
        if (this._hvo.state == States.Opening) {
            this._hvo.forceLoad();
        }
        else if (this._hvo.state >= States.Opened && this._hvo.state != States.Playing) {
            this._hvo.play();
        }
    }
    close() {
        this._hvo.close();
        this.onClose();
    }
    onClose() { }
    pause() {
        this._hvo.pause();
    }
    setLogLevel(level) {
        this._hvo.logLevel = level;
    }
    setAudioEnabled(enabled) {
        this._hvo.setAudioEnabled(enabled);
    }
    audioEnabled() {
        return this._hvo.audioEnabled();
    }
    setAudioVolume(volume) {
        this._hvo.setAudioVolume(volume);
    }
    setAutoLooping(loop) {
        this._hvo.setAutoLooping(loop);
    }
}
//# sourceMappingURL=holoVideoFrontEnd.js.map